import React from "react";
import { css } from "styled-components";
import { Button, H2, H3, Paragraph, Section } from "../../Styles/Global.Styled";
import { useNavigate } from "react-router-dom";

const sectionStyle = (bgImg) => css`
  background-image: url(${bgImg});
  background-size: cover;
  background-position: center center;
  padding: 7vh 20vw;
  align-items: center;
  justify-content: center;
  gap: 3vh;
  margin: 5vh 0;
`;
const sectionStyleMb = css`
  padding: 7vh 10vw;
`;
const h3Style = css`
  font-size: 1.8vh;
`;
const h2Style = (color) => css`
  color: ${color && color};
  margin-top: -2vh;
`;
const paragraphStyle = (color, fontSize) => css`
  text-align: center;
  color: ${color && color};
  font-size: ${fontSize && "2.5vh"};
`;
const bttnStyle = css`
  border: 2px solid white;
  font-size: 2.5vh;
  color: white;
  min-width: 20vh;
  padding: 0.75vh 1vh;
  border-radius: 25px;
`;

const SectionType2 = ({ content = {} }) => {
  const navigate = useNavigate();
  return (
    <Section
      id={content.id}
      $baseStyle={sectionStyle(content.img)}
      $mStyle={sectionStyleMb}
    >
      <H3 $baseStyle={h3Style}>{content.subHeader}</H3>
      <H2 $baseStyle={h2Style(content.color)}>{content.header}</H2>
      <Paragraph $baseStyle={paragraphStyle(content.color, content.fontSize)}>
        {content.paragraph}
      </Paragraph>
      {content.cta && content.url && (
        <Button $baseStyle={bttnStyle} onClick={() => navigate(content.url)}>
          {content.cta}
        </Button>
      )}
    </Section>
  );
};

export default SectionType2;
